import { useState } from 'react';
import t from 'prop-types';

function useInput(valorInicial, funcionDeValidacion) {
  var _useState = useState(valorInicial),
      valor = _useState[0],
      setValor = _useState[1];

  function handleChange(event) {
    var valorValidado = funcionDeValidacion ? funcionDeValidacion(event.target.value) : event.target.value;
    setValor(valorValidado);
  }

  return {
    valor: valor,
    setValor: setValor,
    reset: function reset() {
      return setValor('');
    },
    bind: {
      value: valor,
      onChange: handleChange
    }
  };
}

useInput.propTypes = {
  valorInicial: t.string,
  transformador: t.func
};
export default useInput;